const { h, Component } = require('preact');
const FeedbackSuceess = require('../../views/customer_feedback/feedback_suceess');
const FeedbackForm = require('../../views/customer_feedback/feedback_form');

class FeedbackModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFeedbackSuccessWidget: false
    }
    this.showFeedbackSuccessWidget = this.showFeedbackSuccessWidget.bind(this);
  }

  showFeedbackSuccessWidget() {
    this.setState({ showFeedbackSuccessWidget: true });
  }

  render() {
    return (
      <div id="feedback-form-modal">
        <div class="modal show-modal">
          <div class="modal-body">
            <div class="modal-title">
              { I18n.translate('js.modules.web_2018.feedback.title') }
            </div>
            {
              this.state.showFeedbackSuccessWidget ? <FeedbackSuceess {...this.props} /> : 
                <FeedbackForm {...this.props} showFeedbackSuccessWidget={this.showFeedbackSuccessWidget} />
            }
          </div>
        </div>
      </div>
    )
  }
}

module.exports = FeedbackModal;